'use strict';

// ==================================================================
//  Config
// ==================================================================
var config = {
  slideshowTimer: 3500,
  smoothScrollTime: 500,
  mobileNavSpeed: 0.3,
  imgFadeSpeed: 1.25,
  loadingAnim: {
    speed: 1,
    delay: 0.1
  }
};

// ==================================================================
//  Variables / DOM selectors
// ==================================================================
var $root = $('html, body');
var $body = $('body');
var $wrapper = $body.find('.wrapper');
var $footer = $body.find('footer');
var $slideshow = $root.find('.slideshow');
var $lazy = $root.find('.lazy');
var $navs = $root.find('header, .mobile-nav-wrapper, .fixed-header, footer');
var $fixedHeader = $root.find('.fixed-header');
var $navsA = $navs.find('ul').find('a');
var $mobileNavToggle = $root.find('.mobile-nav-toggle');
var $mobileNavWrapper = $root.find('.mobile-nav-wrapper');
var $collectionImages = $root.find('.content').find('.collection-images').find('a');
var $hoverImg = $root.find('.hover-img');

// ==================================================================
//  Document ready event
// ==================================================================
$(document).ready(function () {

  // Show fixed header if document was scrolled
  toggleFixedHeader();

  // Fixed header funcitonality
  initFixedHeader();

  // Initialize Flickity slideshow plugin
  $slideshow.flickity({
    wrapAround: true,
    cellAlign: 'center',
    autoPlay: config.slideshowTimer,
    dragThreshold: 10
  });

  // Follow hash if it is set
  if (location.hash) {
    window.location.hash = location.hash;
  }

  // Initialize Unveil plugin
  $lazy.unveil(100, function () {
    $(this).on('load', function () {
      this.style.opacity = 1;
      this.style.width = 'auto';
      TweenMax.from(this, config.imgFadeSpeed, { y: 50, ease: Power4.easeOut });
    });
  });

  // Initialize Featherlight plugin
  $collectionImages.featherlightGallery({
    previousIcon: '',
    nextIcon: ''
  });

  // Smooth scrolling to anchor
  $navs.find('a').click(function () {
    smoothScroll($(this));
    return false;
  });

  // Toggle mobile nav
  $mobileNavToggle.click(function (e) {
    e.stopPropagation();
    animateMobileNavHeight();
  });
  $root.click(function () {
    $mobileNavToggle.hasClass('open') ? animateMobileNavHeight() : '';
  });

  // Image link hover effect
  $hoverImg.on('mouseover', function () {
    TweenMax.to($(this).find('img'), 0.3, { scale: 1.05, ease: Power1.easeInOut });
  }).on('mouseleave', function () {
    TweenMax.to($(this).find('img'), 0.3, { scale: 1, ease: Power1.easeInOut });
  });

  // Remove loader when it was played once
  //($.session.get('loaded') ? $('.loader').remove() : '');
});

// ==================================================================
//  Window load event
// ==================================================================
$(window).on('load', function () {

  // Show slideshow once window is loaded
  $slideshow.find('.slideshow-cell').removeClass('hidden');

  // Set wrapper padding if there is not enough content
  setWrapperPadding();

  // Loading animation
  //(!$.session.get('loaded') ? TweenMax.staggerTo('.loader-segment', config.loadingAnim.speed, {cycle:{ y: [$(window).height(), -$(window).height()] }, ease:Power4.easeInOut, onComplete: function() { $.session.set('loaded', true) }}, config.loadingAnim.delay) : '');
});

// Follow hash after Flickity initialization if it is set
Flickity.prototype.on('activate', function () {
  if (location.hash) {
    window.location.hash = location.hash;
  }
});

// ==================================================================
//  Window scroll event
// ==================================================================

// Toggle fixed header on scroll
$(window).on('scroll', toggleFixedHeader);
$(window).on('resize', setWrapperPadding);

// ==================================================================
//  Functions
// ==================================================================

// Smooth scrolling to anchor
function smoothScroll($elem) {
  var href = $elem.attr('href');
  $root.animate({
    scrollTop: $(href).offset().top
  }, config.smoothScrollTime, function () {
    window.location.hash = href;
  });
}

// Mobile nav height animation
function animateMobileNavHeight() {
  if ($mobileNavToggle.hasClass('open')) {
    TweenMax.to($mobileNavWrapper, config.mobileNavSpeed, { height: 0 });
    $mobileNavToggle.removeClass('open');
  } else {
    TweenMax.set($mobileNavWrapper, { height: 'auto' });
    TweenMax.from($mobileNavWrapper, config.mobileNavSpeed, { height: 0 });
    $mobileNavToggle.addClass('open');
  }
}

// Show fixed header nav
function toggleFixedHeader() {
  if ($(window).scrollTop() > $('header').height()) {
    $fixedHeader.addClass('visible');
  } else {
    $fixedHeader.removeClass('visible');
  }
}

// Initialize fixed header functionality
function initFixedHeader() {
  if (location.hash) {
    $('a[href="' + location.hash + '"]').addClass('active');
  } else {
    $('a[data-page="' + $body.attr('id') + '"]').addClass('active');
  }

  // Set active class for clicked link
  $navsA.click(function () {
    $navsA.removeClass('active');
    $('a[href="' + $(this).attr('href') + '"]').not('.logo').addClass('active');
  });

  // Scroll top when clicking the active link
  $fixedHeader.find('a').not('.logo').click(function (e) {
    e.stopPropagation();
    $(window).width() < 1441 && !$(this).parent().hasClass('social-links') ? e.preventDefault() : '';
  });
  $fixedHeader.click(function (e) {
    e.preventDefault();
    $root.animate({
      scrollTop: 0
    }, config.smoothScrollTime);
  });
}

// Set wrapper padding if there is not enough content
function setWrapperPadding() {
  if ($body.height() < $(document).height()) {
    $wrapper.css('margin-bottom', $(document).height() - ($('header').height() + $footer.height() + $wrapper.outerHeight() + parseInt($('.collection-header').css('marginTop'), 10)));
  }
}